// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-promo-code-label-shrinked{right:unset;white-space:nowrap}\n", ""]);
// Exports
module.exports = exports;
